class IntercomContact extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");
    if (!this.form) return;

    this.errorEl = this.querySelector(".icf-error");
    this.successEl = this.querySelector(".icf-success");
    this.btn = this.querySelector('button[type="submit"]');
    this.btnText = this.querySelector(".icf-btn-text");
    this.btnSpin = this.querySelector(".icf-btn-spin");

    this._onSubmit = this._onSubmit.bind(this);
    this.form.addEventListener("submit", this._onSubmit, false);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("submit", this._onSubmit, false);
  }

  _busy(b) {
    if (!this.btn) return;
    this.btn.disabled = b;
    if (this.btnText) this.btnText.classList.toggle("hidden", b);
    if (this.btnSpin) this.btnSpin.classList.toggle("hidden", !b);
  }

  _showError(msg) {
    if (this.successEl) this.successEl.classList.add("hidden");
    if (this.errorEl) {
      this.errorEl.textContent = msg;
      this.errorEl.classList.remove("hidden");
    }
  }

  _showSuccess() {
    if (this.errorEl) this.errorEl.classList.add("hidden");
    if (this.successEl) this.successEl.classList.remove("hidden");
  }

  async _onSubmit(e) {
    e.preventDefault();
    this._busy(true);

    const fd = new FormData(this.form);
    const payload = {
      name: (fd.get("name") || "").toString().trim(),
      email: (fd.get("email") || "").toString().trim(),
      message: (fd.get("message") || "").toString().trim(),
    };

    if (!payload.name || !payload.email || !payload.message) {
      this._busy(false);
      return this._showError("Please complete all fields.");
    }

    try {
      const res = await fetch(
        "https://feno-co-tjjv.vercel.app/api/contact",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      if (!res.ok) throw new Error(await res.text());
      this._showSuccess();
      this.form.reset();
    } catch (err) {
      this._showError("We couldn’t send your message. Please try again.");
      console.error("[intercom-contact] submit error:", err);
    } finally {
      this._busy(false);
    }
  }
}

customElements.define("intercom-contact", IntercomContact);
